// config.js
// 图片、接口的基础域名，后期换域名只改这一行！
export const BASE_URL = 'https://asdf.hbbtfbf.cn'
// export const BASE_URL = 'http://124.221.86.200:80'
/**
 * 图片地址拼接函数
 * @param {String} path 后端返回的 /upload/xxx.png
 * @returns 完整图片地址
 */
export function getImageUrl(path) {
  if (!path) return ''
  // 如果path已经是http/https完整地址，直接返回，不再拼接
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  return BASE_URL + path
}
